import * as React from 'react';
import { useSelector } from 'react-redux';
import { RateSuburban } from '../../components/RateSuburban';
import { EScrollingBlocks } from '../../constants/scrollingBlocks';
import { selectIsDesktop } from '../../selectors/page';
import { useScrollToBlock } from '../Scrolling';

export const RateSuburbanContainer: React.FC = () => {
  const isDesktop = useSelector(selectIsDesktop);
  const scrollToBlock = useScrollToBlock();
  const scrollToFilters = () => {
    scrollToBlock(EScrollingBlocks.ValuationFilters);
  };

  return <RateSuburban isDesktop={isDesktop} onClick={scrollToFilters} />;
};

RateSuburbanContainer.displayName = 'RateSuburbanContainer';
